/* istanbul ignore file */
import React from 'react';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import SingleServiceBreadcrumbs from 'domain/organization/service/shared/SingleServiceBreadcrumbs';

const UpdateServiceBreadcrumbs = () => {
  return (
    <SingleServiceBreadcrumbs>
      <UpdateBreadcrumbItem />
    </SingleServiceBreadcrumbs>
  );
};

export default UpdateServiceBreadcrumbs;
